import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
const Columns = () => {
		let columns = [
			{
				id: 'number',
				name: 'Unidad',
				selector: row => row.number,
				sortable: true,
			},
			{
				id: 'owner',
				name: 'Propietario',
				selector: row => row.owner,
				sortable: true,
				minWidth: '200px',
			},
			{
				id: 'salidas_count',
				name: 'No. Salidas',
				selector: row => row.salidas_count,
				sortable: true,
			},
			{
				id: 'pasajeros',
				name: 'Pasajeros',
				selector: row => row.pasajeros,
				sortable: true,
			},
			{
				id: 'ingreso',
				name: 'Ingreso',
				selector: row => row.ingreso,
				sortable: true,
			},
		];
	return columns;
}

export default Columns;

//vaneton beicli